<template>
  <div class="activity-library-drafts-table">
    <ActivityLibraryTable
      :data="data"
      :count="count"
      :title="title"
      :isDisplayViews="true"
      @changeView="changeView"
      :currentView="currentView"
      :isPaginate="true"
      :views="activityViews"
      @previewActivity="previewActivity($event)"
      @onPinActivity="onPinActivity"
      @onUnpinActivity="onUnpinActivity"
      @onSortColumn="onSortColumn"
      @onPageChange="onPageChange"
      :pagination="pagination"
      @changeStatustoArchive="changeStatustoArchive"
      @refreshActivityList="refreshActivityList"
      :viewMode="viewMode"
      :studyId="studyId"
      :previewSelectedId="previewSelectedId"
      tableType="Published"
      :migrationData="migrationData"
    ></ActivityLibraryTable>
  </div>
</template>

<script>
import ActivityLibraryTable from "@/components/activity-library/activity-library-table";
import * as columnNames from "@/constants/activity-library-and-configurator-component/column-names";
import _ from "lodash";
export default {
  name: "activity-thread-library",
  components: {
    ActivityLibraryTable
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    count: {},
    title: {
      type: String,
      default: "Activities"
    },
    currentView: {
      type: Number
    },
    views: {},
    pagination: {},
    viewMode: {
      type: Boolean,
      default: false
    },
    studyId: null,
    migrationData: { type: Object },
    previewSelectedId: null
  },
  computed: {
    activityViews() {
      const activityViews = _.cloneDeep(this.views);
      activityViews["1"].push(columnNames.ACTION);
      activityViews["2"].push(columnNames.ACTION);
      activityViews["1"].unshift(columnNames.PREVIEW);
      activityViews["2"].unshift(columnNames.PREVIEW);
      activityViews["1"].unshift(columnNames.PIN);
      activityViews["2"].unshift(columnNames.PIN);
      return activityViews;
    }
  },
  methods: {
    changeView(view) {
      this.$emit("changeView", view);
    },
    onPinActivity(reqObj) {
      this.$emit("onPinActivity", reqObj);
    },
    onUnpinActivity(reqObj) {
      this.$emit("onUnpinActivity", reqObj);
    },
    onSortColumn(eventData) {
      this.$emit("onSortColumn", eventData);
    },
    onPageChange(direction) {
      this.$emit("onPageChange", { direction, tableTitle: this.title });
    },
    previewActivity(previewActivityObj) {
      this.$emit("previewActivity", previewActivityObj);
    },
    changeStatustoArchive(reqObj) {
      this.$emit("changeStatustoArchive", reqObj);
    },
    refreshActivityList(reqObj) {
      this.$emit("refreshActivityList", reqObj);
    }
  }
};
</script>

<style scoped lang="scss">
.action-dropdown-menu {
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 1px 1px;
  min-width: 7rem;
}
</style>
